import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=32c79b0b&scoped=true&"
import script from "./NewLogin.vue?vue&type=script&lang=ts&"
export * from "./NewLogin.vue?vue&type=script&lang=ts&"
import style0 from "./NewLogin.vue?vue&type=style&index=0&id=32c79b0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c79b0b",
  null
  
)

export default component.exports